import React from "react"

import { Container } from "@material-ui/core"
import Layout from "../components/Layout"
import { Link } from "gatsby"
//import { Picture } from 'react-responsive-picture';

import Hero from "./../components/Hero"

import CTA from "./../components/CTA"

import problem_statement from "../assets/about-us/it-started-with-a-problem-statement.png"
import team_inviz from "../assets/about-us/the-team-became-inviz.png"



import excellence from "../assets/about-us/excellence.png"
import empathy from "../assets/about-us/empathy.png"
import ethical from "../assets/about-us/ethical.png"

import identity from "../assets/about-us/our-identity.png"




function AboutUs() {
  return (
    <Layout
      cssClass="about-us-page"
      title="INVIZ AI Solutions | About Us"
      description="We are a global software and intelligence consultancy company focused on building software, cloud and data solutions with intelligence."
    >
      <Hero>
        <h1><strong>We are <span className="green">Problem Solvers</span></strong></h1>
      </Hero> 

      <section className="about-us__story">
          <Container>
         
          <header className="centered">
            <h3>              
                <strong>Our <span className="green">Story</span></strong>              
            </h3>           
          </header>
          
          <div className="content">
            <div className="content_1">
            <figure>
              <img src={problem_statement} alt="It all started with a problem statement"/>
            </figure>
            <div className="text">
            <p >
                Much like Inviz’s positioning,<br /><b className="green">our story started with a problem statement.</b>
          </p> 
              <p>
                Back in 2019, a current client (acquaintance then), required{" "}
                <b className="green">eCommerce Search Optimisation</b>{" "}
                integrated with <b className="green">artificial intelligence</b>, such that endusers can find and discover retail products from their catalog with ease.
              {" "}
              </p>
              <p>
                The client was finding it hard to identify a technology partner who can solve the complex business problem within the given time frame.
              </p>
              <p>
                
                Finally they reached our founder, PK, who assembled a multi disciplinary team comprised of scientists, engineers,
                designers and analysts with the right domain knowledge. Once the problem was solved, the team realised that there were many such opportunities in the market for ML & AI services.
              </p>
              </div>
              </div>
              <div className="content_2">
              <figure>
                <img src={team_inviz} alt="The Team became Inviz"/>
              </figure>
              <div className="text">
              <p className="large">
                <b className="green">The Team became Inviz</b>.
              </p>
              <p>
                Subsequently, we started getting more and more projects based on positive word of mouth exposure. We started scouting for individuals who are good at problem solving, and are skilled at various technologies, including ML & AI, IOT, etc. Gradually our team grew and now we are located in two countries, India and the United States.  
              </p>
              <p>Do get in touch with us to know how <b className="green">Inviz can help your business</b>.</p>
              <br/>
              <Link to="contact-us" className="btn">
                <span>Get in Touch</span>
              </Link>
              </div>
              </div>
            </div>          
          </Container>
        </section>    
      
        <section className="about-us__values">
          <Container>
          <header className="centered">           
            <h3>             
             <strong>Our <span className="green">Values</span> </strong>           
            </h3>            
          </header>
          <p className="large">
            Our values are a set of things that we are unwilling to{" "}
            <b className="green">compromise under any circumstances</b>
          </p>
          <ul className="about-us__values__list flex">
            <li className="xs-12 md-4">
              <div>
              <figure>
                <img src={excellence} alt="Excellence in quality of solutions"/>
              </figure>
              <div className="txt">
                <h4> 
                  <b>             
                    <span className="green">Excellence</span><br/> in quality of
                    solutions
                    </b>                      
                </h4>
                <p>
                  At Inviz, we take pride in the quality of solutions we
                  deliver. To us, quality comprises of two dimensions - time, and
                  business value. We constantly strive to ensure that the best
                  solutions are delivered in a timely fashion to ensure maximum
                  business value.{" "}
                </p>
              </div>
              </div>
            </li>

            <li className="xs-12 md-4">
              <div>

              <figure>
                <img src={empathy} alt="Empathy for people and their problems"/>
              </figure>
              <div className="txt">
                <h4>
                  <b>
                    <span className="green">Empathy</span><br/> for people &amp;
                    their problems
                  </b>                  
                </h4>
                <p>
                  We believe technology is a tool that solves human problems.
                  We focus empathising with our client's business
                  aspirations and pain points.This empathy is a key differentiator in navigating through various business problems and identifying suitable solutions.
                </p>
              </div>
              </div>
            </li>

            <li className="xs-12 md-4">
              <div>
            <figure>
                <img src={ethical} alt="Ethical interactions and engagements"/>
              </figure>
              <div className="txt">
                <h4>   
                  <b>              
                    <span className="green">Ethical</span><br/> 
                    interactions &amp; engagements     
                    </b>              
                </h4>
                <p>
                  Be it clients, employees or a random person, we believe in
                  playing fair. While we are a for-profit organization, we are a
                  set of individuals who believe in doing the right thing, even
                  if it’s not financially prudent.
                </p>
              </div>
              </div>
            </li>
          </ul>
          </Container>
        </section>
        <Container>
        <div className="gradient-bar mobile-only"></div>
        </Container>   

        <Container>
        <div className="gradient-bar mobile-only"></div>
        </Container>   
        <section className="about-us__identity">
          <Container>
            <header className="centered">
            <h3>
              <strong>Our <span className="green">Identity</span></strong>
            </h3>
            </header>
            <p className="large"><em>Our clients love us for the way we take a complex problem and find an elegant solution that delivers business value.</em></p>
          
          <div className="content">         
            <div className="text">
            <p>While we have a wide breath of experience in various technologies, we have developed niche expertise and experience in AI, ML, and cloud technology. 
            </p>
            <p>If you want to know more about how AI and ML can make your company better, or you want help with taking your business solutions to the cloud or discuss any complex problem that risks your business or stopping you from exploiting an opportunity, do give us a call. 
            </p>
            </div>
            <figure>
              <img src={identity} alt="Inviz Ai : Our Identity"/>
            </figure>
          </div>          
          </Container>
          </section>  
          <CTA />
    </Layout>
  )
}

export default AboutUs



